import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.viewHandlingList.details.statusSection.title',
    defaultMessage: 'Status',
    description: 'label of the handling lists status section',
  },
  properties: {
    isFinished: {
      id: 'properties.isFinished',
      defaultMessage: 'Finished',
      description: 'label of the handling lists status is finished',
    },
    isInProgress: {
      id: 'properties.isInProgress',
      defaultMessage: 'In progress',
      description: 'label of the handling lists status is in progress',
    },
    isOnHold: {
      id: 'properties.isOnHold',
      defaultMessage: 'On hold',
      description: 'label of the handling lists status is on hold',
    },
    isOutbound: {
      id: 'properties.isOutbound',
      defaultMessage: 'Outbound',
      description: 'label of the handling lists status is outbound',
    },
    isServiced: {
      id: 'properties.isServiced',
      defaultMessage: 'Serviced',
      description: 'label of the handling lists status is serviced',
    },
  },
};

export default defineMessages(translations);
